/*
 * @Author: your name
 * @Date: 2019-12-10 22:17:21
 * @LastEditTime : 2020-02-12 11:14:13
 * @LastEditors  : LIANGYU
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Router from "vue-router";
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
import "@/assets/css/Init.css"; //初始化css文件
import "../static/public/JS/Rem"; //初始化rem文件
import "@/style/common.css"; //公用的css
/**
 * 引入vant框架
 */
import Vant from "vant";
import { Toast } from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
Vue.use(preview);

Vue.use(ElementUI);
Vue.config.productionTip = false;
import { getToken } from "./untils/token";
import { jsApiTicket } from "@/api/index";
import wx from "weixin-js-sdk";
Vue.isIosOrAndroid = function() {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  let isStr = "";
  if (isAndroid) {
    isStr = "android";
  }
  if (isiOS) {
    isStr = "ios";
  }
  return isStr;
};

router.beforeEach((to, from, next) => {
  if (to.fullPath == "/home/personalCenter") {
    if (!getToken()) {
      Toast("登录已超时，请重新登录");
      next("/home/login");
    }
  }
  if (to.meta.name) {
    document.title = to.meta.name;
  } else {
    document.title = "铭筑工匠";
  }
  if (!window.initUrl) {
    window.initUrl = location.href.split("#")[0];
  }
  let urls =
    Vue.isIosOrAndroid() === "android"
      ? location.href.split("#")[0]
      : window.initUrl;
  jsApiTicket({
    url: urls
  }).then(res => {
    if (res.state == 200) {
      window.url = res.datas.url;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: "wxb21eef7e1688b8e9", // 必填，公众号的唯一标识
        timestamp: res.datas.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.datas.nonceStr, // 必填，生成签名的随机串
        signature: res.datas.signature, // 必填，签名
        jsApiList: [
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ"
        ] // 必填，需要使用的JS接口列表
      });
    }
  });
  next();
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js